/* eslint-env jquery */

import ReportTable from '../handlers/report-table'

onDomLoad(() => {
  $("[data-behaviour='report-navbar-display-options']")
    .off('click')
    .on('click', (event) => {
      const dataset = event.target.dataset
      window.modalCitizen.openModal('report-display-options-modal', {
        locales: JSON.parse(dataset.locales),
        currentLocale: dataset.current_locale,
        currentShowAccountsAs: dataset.current_show_accounts_as,
        currentShowAccountNumbers: dataset.current_show_account_numbers
          ? JSON.parse(dataset.current_show_account_numbers)
          : dataset.current_show_account_numbers,
      })
    })

  $("[data-behaviour='report-navbar-analytical-dimensions']")
    .off('click')
    .on('click', (event) => {
      const dataset = event.target.dataset
      window.modalCitizen.openModal('report-analytical-dimensions-modal', {
        formattedDimensions: JSON.parse(dataset.formatted_dimensions),
        editDimensionsUrl: dataset.edit_dimensions_url,
      })
    })
})

$(document).on(
  'click',
  "[data-behaviour='report-table-expand-all']",
  (event) => {
    event.preventDefault()
    new ReportTable($(document)).expandAll()
  }
)

$(document).on(
  'click',
  "[data-behaviour='report-table-collapse-all']",
  (event) => {
    event.preventDefault()
    new ReportTable($(document)).collapseAll()
  }
)
